'use strict';

var merge = require('merge');

module.exports = function (defaults, globalOptions, localOptions) {

  if (globalOptions) defaults = merge.recursive(defaults, globalOptions);

  localOptions = merge.recursive(defaults, localOptions);

  return localOptions;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/init-options.js
// module id = 250
// module chunks = 0